export const adminConstant = {
  DATA_FETCHED: "DATA_FETCHED",
  ALL_ADMINS: "ALL_ADMINS",
  DATA_FETCHED_PATIENT_BY_MONTH_DATE: "DATA_FETCHED_PATIENT_BY_MONTH_DATE",
  DATA_FETCHED_PATIENT_BY_DATE_RANGE_OF_ALL_LOCATION:
    "DATA_FETCHED_PATIENT_BY_DATE_RANGE_OF_ALL_LOCATION",
};
